import { hasAddressLine2AsCustom } from "@shared/utils";
import { DetailedSurvey } from "@survey-types/survey.core.types";
import { Property } from "@survey-types/survey.property.types";
import { FieldData } from "./heightPagination";

export const processPropertyFields = (
  property: Property,
  survey: DetailedSurvey | null,
): FieldData[] => {
  const isAddressLine2Custom = survey ? hasAddressLine2AsCustom(survey) : true;

  // Use propertyFieldRuleList from survey to determine which fields to show and their order
  const propertyFieldRules =
    survey?.surveyPropertyFieldRule?.propertyFieldRuleList || [];

  // Filter out hidden fields, comments, amenities, and name, then sort by order
  const visibleFieldRules = propertyFieldRules
    .filter((rule) => !rule.isHidden)
    .filter(
      (rule) =>
        rule.fieldKey !== "comments" &&
        rule.fieldKey !== "amenities" &&
        rule.fieldKey !== "name" &&
        rule.fieldKey !== "address1" &&
        (isAddressLine2Custom || rule.fieldKey !== "address2") &&
        rule.fieldKey !== "city" &&
        rule.fieldKey !== "stateProvince" &&
        rule.fieldKey !== "postalCode",
    )
    .sort((a, b) => a.order - b.order);

  // Map field rules to property data with custom fields support
  return visibleFieldRules.map((rule) => {
    const { fieldKey, fieldId } = rule;
    let fieldValue: string;

    // Handle custom fields when fieldKey is null/undefined
    if (fieldKey == null && fieldId) {
      // Find custom field by matching customFieldId with fieldId
      const customField = property.customFields?.find(
        (cf) => cf.customField.customFieldId === fieldId,
      );
      fieldValue = customField?.value || "—";
    } else if (fieldKey) {
      // Handle standard property fields
      fieldValue = (property[fieldKey as keyof Property] as string) || "—";
    } else {
      // Fallback for unknown field types
      fieldValue = "—";
    }

    return {
      label: rule.fieldLabel,
      value: fieldValue,
    };
  });
};
